import React from 'react';
import { Shield, Building, DollarSign, Ship, Users } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

const WhyGoldenPort = () => {
  const navigate = useNavigate();

  const reasons = [
    {
      icon: Shield,
      title: 'Verified Global Buyers',
      description: 'We work only with verified and trustworthy international buyers who have proven track records.'
    },
    {
      icon: Building,
      title: 'Bank-Supported Trade Structure',
      description: 'All transactions are structured through banking channels ensuring transparency and security.'
    },
    {
      icon: DollarSign,
      title: 'Controlled Export Collections',
      description: 'Payment collections are managed and controlled to eliminate payment risks.'
    },
    {
      icon: Ship,
      title: 'Risk-Protected Shipments',
      description: 'Every shipment is protected through proper documentation and insurance mechanisms.'
    },
    {
      icon: Users,
      title: 'Reliable Indian Suppliers',
      description: 'We onboard only quality-conscious Indian manufacturers with proven production capabilities.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-[500px] flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(11, 44, 77, 0.9), rgba(11, 44, 77, 0.9)), url('https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1920')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Why Choose GoldenPort?</h1>
          <p className="text-2xl max-w-3xl mx-auto">
            Your trusted partner for safe and successful exports
          </p>
        </div>
      </section>

      {/* Reasons Section */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto space-y-8">
            {reasons.map((reason, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border-t-4 border-[#C9A24D]"
              >
                <div className="flex items-start gap-6">
                  <div className="bg-[#0B2C4D] p-5 rounded-lg flex-shrink-0">
                    <reason.icon className="w-12 h-12 text-[#C9A24D]" />
                  </div>
                  <div>
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-3xl font-bold text-[#C9A24D]">✓</span>
                      <h3 className="text-2xl font-bold text-[#0B2C4D]">{reason.title}</h3>
                    </div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#0B2C4D] text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Experience the GoldenPort Advantage</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join successful Indian exporters who trust GoldenPort for their international trade.
          </p>
          <Button 
            size="lg"
            className="bg-[#C9A24D] hover:bg-[#b8923e] text-[#0B2C4D] font-semibold text-xl px-12 py-7"
            onClick={() => navigate('/contact')}
          >
            Get Started Today
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WhyGoldenPort;
